import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ArrowLeft = function ArrowLeft(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size * 1.166666667,
    height: size,
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      fillRule: "evenodd",
      d: "M14 6a1 1 0 00-1-1H3a1 1 0 100 2h10a1 1 0 001-1z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      fillRule: "evenodd",
      d: "M8.067.3A1 1 0 006.653.286L.603 6.229l6.079 5.512a1 1 0 001.343-1.482L3.516 6.171l4.538-4.458A1 1 0 008.067.3z",
      clipRule: "evenodd"
    })]
  });
};
export default ArrowLeft;